export default __webpack_public_path__ + "static/media/solar-panel.29d228a4.jpeg";